import { 
  Heart, 
  Shield, 
  BarChart3, 
  Star, 
  AlertTriangle, 
  Users, 
  DollarSign, 
  Zap 
} from "lucide-react";

const HoroscopeInsights = () => {
  const insights = [
    {
      icon: Heart,
      title: "Ashtakoot Gun Milan",
      bgColor: "bg-red-500",
    },
    {
      icon: Shield,
      title: "Dashakoot Gun Milan",
      bgColor: "bg-red-600",
    },
    {
      icon: BarChart3,
      title: "Manglik Dosha Analysis",
      bgColor: "bg-red-500",
    },
    {
      icon: Star,
      title: "Nadi Dosha Analysis",
      bgColor: "bg-red-600",
    },
    {
      icon: AlertTriangle,
      title: "Bhakoot Dosha Analysis",
      bgColor: "bg-red-500",
    },
    {
      icon: Users,
      title: "Personality Report",
      bgColor: "bg-red-600",
    },
    {
      icon: DollarSign,
      title: "Indicating Flaws",
      bgColor: "bg-red-500",
    },
    {
      icon: Zap,
      title: "Emotional Compatibility",
      bgColor: "bg-red-600",
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-r from-orange-400 via-red-400 to-orange-500">
      <div className="container mx-auto px-4">
        <div className="text-center text-white mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            Beyond Horoscopes: Discover the True Compatibility of Your Relationship
          </h2>
          <h3 className="text-2xl lg:text-3xl font-semibold mb-8">
            It’s not just about matching charts — it’s about understanding love, harmony, and your future together.
          </h3>
          <p className="text-lg max-w-4xl mx-auto leading-relaxed">
            With detailed insights, you’ll know where your strengths lie, what challenges may arise, and the remedies to build a stronger bond.

          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {insights.map((insight, index) => {
            const IconComponent = insight.icon;
            return (
              <div
                key={index}
                className="bg-white rounded-2xl p-6 text-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
              >
                <div className={`w-16 h-16 ${insight.bgColor} rounded-full flex items-center justify-center mx-auto mb-4`}>
                  <IconComponent className="w-8 h-8 text-white" />
                </div>
                <h4 className="text-sm font-semibold text-gray-800 leading-tight">
                  {insight.title}
                </h4>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HoroscopeInsights;